<template>
  <div>
    <div class="vuse-content-wrapper mt-4">
      <div>
          <v-row >
            <v-col>              
              <h2 class="ml-3">
                {{$t(page+'.Users')}}
                <!--
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <ExcelIcon />
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                -->
                <span class="ml-2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn fab icon small color="info" v-on="on" @click="getData()" :loading="loading" class="neu-glow">
                        <v-icon>mdi-sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
              </h2>
            </v-col>

            
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right pr-8">
              <v-btn @click="dialog_range=true">Periodo: {{rangeString}}</v-btn>
            </v-col>              
          </v-row>
          <template v-if="customers.length==0 && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5">
              <v-col cols="12" class="ma-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title>
                    <v-row>
                      <div class="ml-5 pt-3" v-if="customers">Margine: {{(totals.totAmountPBX+totals.totAmountWAM-totals.totCostPBX-totals.totCostWA).toFixed(2)}}</div>
                      <v-spacer></v-spacer>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                          class="mt-n4"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-data-table
                      :loading="customers.length==0"
                      fixed-header="true"
                      :headers="headers"
                      :items="customers"
                      :items-per-page="5000"
                      :height="wIH - 289"
                      :search="search"
                      loading-text="Loading... Please wait"
                      :hide-default-footer="true"
                      class="mx-5 neu-glow"

                  >              

                    <template v-for="(h,hi) in headers" v-slot:[`header.${h.value}`]="{ header }">
                      <v-tooltip top :key="hi" :class="header">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{h.text}}</span>
                        </template>
                        <span>{{h.description}}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:[`item.createdDate`]="{ item }">
                      <v-span>{{item.createdDate}}<br />{{item.expiryDate}}</v-span>
                    </template>
           
                    
                    <template v-slot:[`item.brand`]="{ item }">
                      <v-div>{{item.brand}}</v-div>
                    </template>

                    <template v-slot:[`item.active`]="{ item }">
                      <v-switch color="info" 
                      @click="save(item,'active','account')" 
                      v-model="item.active"
                      :label="item.active?'SI':'NO'"
                      >
                      </v-switch>
                    </template>  

                    <template v-slot:[`item.expired`]="{ item }">
                      <v-switch color="info" 
                      @click="save(item,'expired')" 
                      v-model="item.expired"
                      :label="item.expired<0?'SI':'NO'"
                      >
                      </v-switch>
                    </template>  

                    <template v-slot:[`item.pec`]="{ item }">
                      <v-btn x-small color="primary" @click="openModal(item.uuid,item.userName)" v-model="item.email">Send</v-btn>
                    </template>
                    <template v-slot:[`item.cid`]="{ item }">
                      <v-btn x-small color="primary" @click="dialog_invoicing_open(item)" v-model="item.cid">Dettagli</v-btn>
                    </template>
                    <template v-slot:[`item.modules`]="{ item }">
                      <v-btn x-small color="primary" @click="dialog_modules_open(item)" v-model="item.modules">Moduli</v-btn>
                    </template>

                    <template v-slot:[`item.totCosts`]="{ item }">
                      <span class="error--text">C: {{item.totCosts.toFixed(3)}}</span>
                      <br />
                      <span class="success--text">R: {{item.total_to_Invoice.toFixed(3)}}</span>
                    </template> 

                    <template v-slot:[`item.priceWAUtility`]="{ item }">
                      <span :class="item.total_to_Invoice-item.totCosts>0?'success--text':'error--text'">{{(item.total_to_Invoice-item.totCosts).toFixed(3)}} €</span>
                      <br />
                      <span :class="item.totCosts>item.total_to_Invoice?'error--text':'success--text'">{{(((item.total_to_Invoice/item.totCosts)-1)*100).toFixed(3)}} %</span>
                    </template> 


                    <!--
                    <template v-slot:[`item.password`]="{ item }">
                      <v-btn x-small :color="!item.Password==''?'primary':'secondary'" @click="impersonate(item.email,item.password)">Log</v-btn>
                    </template>
                    -->
                  </v-data-table>
                  </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>
    <v-dialog v-model="msg_modal" max-width="1200">
      <v-card class="overflow-hidden">
        <v-card-title class="text-h5">
          {{$t(page+'.Send a Message')}}
          <v-spacer></v-spacer>
          <v-btn icon @click="msg_modal=false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
          <v-row  class="mt-5">
            <v-col cols="12" md="6">
              <v-img
                src="/static/ob-animated/sent-message-animate.svg"
                lazy-src="/static/ob-animated/sent-message-animate.svg"
                style="height:100%"
              ></v-img>
            </v-col>
            <v-col>
              <v-card-text class="mt-2">
                <p>{{$t(page+'.Send a Message to')+'...'+ username}}</p>
                  <v-text-field
                    :label="$t(page+'.Subject')"
                    :placeholder="$t(page+'.Subject')"
                    outlined
                    v-model="msg.subject"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    v-model="msg.body"
                    name="message"
                    :label="$t(page+'.message')"
                    :placeholder="$t(page+'.message')"
                  ></v-textarea>
                <div class="text-left mt-5">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn 
                        class="mr-5"
                        color="info"
                        @click="msg.body='';msg.subject='';"
                      >{{$t(page+'.Clear')}}</v-btn>
                      <v-btn 
                        :loading="sendingmail"
                        :color="sendbutton_color"
                        @click="messageSend"
                      >{{$t(page+'.'+sendbutton_text)}}</v-btn>
                    </v-col>
                  </v-row>
                  </div>
              </v-card-text>
            </v-col>
          </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="info_dialog" max-width="800">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Instructions')}}</v-card-title
        >
        <v-row class="mx-5">
          <v-col md="6" cols="12">
            {{$t(page+'.ShippingDetailsModalInstructions')}}
          </v-col>  
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="info_dialog=false">
            {{$t(page+'.Close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_invoicing" max-width="1100" v-if="selectedCustomer">
      <v-card class="neu-glow pa-3">
        <v-card-title class="text-h5 mb-3">
          Dettagli Fatturazione: <span class="info--text ml-2">{{selectedCustomer.brand}}</span>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2"  @click="dialog_invoicing=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-card-text class="neu-glow pa-3">
          <v-card class="neu-glow">
            <v-card-title>iVirtualAssistant</v-card-title>
            <v-card-text>
              <v-row class="text-h6">
                <v-col>
                  Descrizione
                </v-col>
                <v-col class="text-center">
                  UM
                </v-col>
                <v-col class="text-right">
                  Valore
                </v-col>
                <v-col class="text-right">
                  Prezzo
                </v-col>  
                <v-col class="text-right">
                  Ricavo €
                </v-col> 
                <v-col class="text-right">
                  Costo €
                </v-col> 
                <v-col class="text-right">
                  Margine €
                </v-col>                                                               
              </v-row>
              <v-row>
                <v-col>
                  Chiamate Ingresso
                </v-col>
                <v-col class="text-center">
                  Minuti (Numero)
                </v-col>
                <v-col class="text-right">
                  {{selectedCustomer.minutesInbound.toLocaleString('it-IT') + ' (' + selectedCustomer.numero_Chiamate.toLocaleString('it-IT')+')'}}
                </v-col>
                <v-col class="text-right">
                  {{selectedCustomer.priceInbound.toFixed(3)}}
                </v-col>
                <v-col class="text-right success--text">
                  {{selectedCustomer.amountInbound.toFixed(3)}}
                </v-col>                               
                <v-col class="text-right error--text">
                  {{selectedCustomer.costInbound.toFixed(3)}}
                </v-col>
                <v-col :class="selectedCustomer.amountInbound>selectedCustomer.costInbound?'text-right success--text':'text-right error--text'">
                  {{(selectedCustomer.amountInbound-selectedCustomer.costInbound).toFixed(3)}}
                </v-col>                
              </v-row> 
              <v-row>
                <v-col>
                  Trasferimento Fisso
                </v-col>
                <v-col class="text-center">
                  Minuti
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.minutesForward.toLocaleString('it-IT')||0}}
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.priceForward.toFixed(3)}}
                </v-col>                  
                <v-col class="text-right success--text">
                  {{(selectedCustomer.amountForward?selectedCustomer.amountForward:0).toFixed(3)}}
                </v-col>
                <v-col class="text-right error--text">
                  {{(selectedCustomer.costForward?selectedCustomer.costForward:0).toFixed(3)}}
                </v-col>
                <v-col :class="selectedCustomer.amountForward>selectedCustomer.costForward?'text-right success--text':'text-right error--text'">
                  {{(selectedCustomer.amountForward-selectedCustomer.costForward).toFixed(3)}}
                </v-col>                                 
              </v-row>
              <v-row>
                <v-col>
                  Trasferimento Mobile
                </v-col>
                <v-col class="text-center">
                  Minuti
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.minutesForwardMobile.toLocaleString('it-IT')}}
                </v-col>
                <v-col class="text-right">
                  {{selectedCustomer.priceForwardMobile.toFixed(3)}}
                </v-col>                
                <v-col class="text-right success--text">
                  {{selectedCustomer.amountForwardMobile.toFixed(3)}}
                </v-col>
                <v-col class="text-right error--text">
                  {{selectedCustomer.costForwardMobile.toFixed(3)}}
                </v-col> 
                <v-col :class="selectedCustomer.amountForwardMobile>selectedCustomer.costForwardMobile?'text-right success--text':'text-right error--text'">
                  {{(selectedCustomer.amountForwardMobile-selectedCustomer.costForwardMobile).toFixed(3)}}
                </v-col>                                
              </v-row>
              <v-row>
                <v-col>
                  Text To Speech
                </v-col>
                <v-col class="text-center">
                  Caratteri
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.tot_chars.toLocaleString('it-IT')}}
                </v-col>
                <v-col class="text-right">
                  0.000
                </v-col>                
                <v-col class="text-right success--text">
                  0.000
                </v-col>                 
                <v-col class="text-right error--text">
                  {{selectedCustomer.costTTS.toFixed(3)}}
                </v-col>
                <v-col :class="0-selectedCustomer.costTTS>0?'text-right success--text':'text-right error--text'">
                  {{(0-selectedCustomer.costTTS).toFixed(3)}}
                </v-col>                  
              </v-row>              
              <v-row>
                <v-col>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>Totali </v-col>
                <v-col> </v-col>
                <v-col> </v-col>
                <v-col> </v-col>
                <v-col class="text-right success--text">
                  {{totAmountPBX}}
                </v-col>
                <v-col class="text-right error--text">
                  {{totCostPBX}}
                </v-col>
                <v-col :class="totAmountPBX-totCostPBX>0?'text-right success--text':'text-right error--text'">
                  {{(totAmountPBX-totCostPBX).toFixed(3)}}
                </v-col>                  
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="neu-glow mt-3">
            <v-card-title>iWhatsAppManager</v-card-title>
            <v-card-text>
              <v-row class="text-h6">
                <v-col>
                  Descrizione
                </v-col>
                <v-col class="text-center">
                  U.M.
                </v-col>                
                <v-col class="text-right">
                  Valore
                </v-col>
                <v-col class="text-right">
                  Prezzo
                </v-col>                                 
                <v-col class="text-right">
                  Ricavo €
                </v-col>                               
                <v-col class="text-right">
                  Costo €
                </v-col>
                <v-col class="text-right">
                  Margine €
                </v-col>                  
              </v-row>
              
              <v-row>
                <v-col>
                  WhatsApp Utility
                </v-col>
                <v-col class="text-center">
                  Conv. (Msg)
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.countWAUtility.toLocaleString('it-IT')}} ({{selectedCustomer.countWAMUtility.toLocaleString('it-IT')}})
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.priceWAUtility.toFixed(3)}}
                </v-col>
                <v-col class="text-right success--text">
                  {{selectedCustomer.amountWAUtility.toFixed(3)}}
                </v-col>
                <v-col class="text-right error--text">
                  {{selectedCustomer.waCostUtility.toFixed(3)}}
                </v-col>
                <v-col :class="selectedCustomer.amountWAUtility>selectedCustomer.waCostUtility?'text-right success--text':'text-right error--text'">
                  {{(selectedCustomer.amountWAUtility-selectedCustomer.waCostUtility).toFixed(3)}}
                </v-col>                 
              </v-row>
              <v-row>
                <v-col>
                  WhatsApp Marketing
                </v-col>
                <v-col class="text-center">
                  Conv. (Msg)
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.countWAMMarketing.toLocaleString('it-IT')}}
                </v-col>                
                <v-col class="text-right">
                  {{selectedCustomer.priceWAMarketing?selectedCustomer.priceWAMarketing.toFixed(3):0.00}}
                </v-col>
                <v-col class="text-right success--text">
                  {{selectedCustomer.amountWAMMarketing.toFixed(3)}}
                </v-col>
                <v-col class="text-right error--text">
                  {{selectedCustomer.waCostMarketing.toFixed(3)}}
                </v-col> 
                <v-col :class="selectedCustomer.amountWAMMarketing>selectedCustomer.waCostMarketing?'text-right success--text':'text-right error--text'">
                  {{(selectedCustomer.amountWAMMarketing-selectedCustomer.waCostMarketing).toFixed(3)}}
                </v-col>                                
              </v-row>
              <v-row>
                <v-col>
                  <v-divider></v-divider>
                </v-col>
              </v-row>              
              <v-row>
                <v-col>Totali </v-col>
                <v-col> </v-col>
                <v-col> </v-col>
                <v-col> </v-col>
                <v-col class="text-right success--text">
                  {{totAmountWA}}
                </v-col>
                <v-col class="text-right error--text">
                  {{totCostWA}}
                </v-col>
                <v-col :class="totAmountWA-totCostWA>0?'text-right success--text':'text-right error--text'">
                  {{(totAmountWA-totCostWA).toFixed(3)}}
                </v-col>                   
              </v-row>
              <v-row>
                <v-col>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="flex-grow-1 flex-shrink-0">
                  <div v-html="invoiceRemarks"></div>
                </v-col>
                <v-col class="text-right flex-grow-0 flex-shrink-1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div>
                        <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2" @click="copyToClipboard(invoiceRemarks2)">
                          <v-icon color="info">mdi-clipboard-arrow-up</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>Copia negli Appunti</span>
                  </v-tooltip>                   
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_modules" max-width="1450" v-if="selectedCustomer">
      <v-card class="neu-glow pa-3">
        <v-card-title class="text-h5 mb-3">
          Dettagli Moduli: <span class="info--text ml-2">{{selectedCustomer.brand}}</span>
          <v-spacer></v-spacer>
          <div>
            <v-menu
              v-model="menu[index]"
              :close-on-content-click="false"
              :nudge-right="40"
              color="info"
              min-width="auto"
              
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateForAllModules"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  label="Data Scadenza Moduli (tutti)"
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  class="mr-12"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateForAllModules"
                locale="it"
                dense
                @input="save(item,'expiry','all');menu[index] = false" 
              ></v-date-picker>
            </v-menu> 
          </div>
          <!--        
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2" @click="dialog_confirm=true">
                  <v-icon color="warning">mdi-calendar-lock</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Imposta data odierna come ultimo giorno attivo su tutti i moduli</span>
          </v-tooltip>
          -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2"  @click="dialog_modules=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-card-text class="neu-glow pa-3">
          <v-data-table
              fixed-header="true"
              hide-default-footer
              disable-sort
              dense
              :headers="module_headers"
              :items="selectedCustomer.modules"
              :items-per-page="10000"
              loading-text="Loading... Please wait"
          >
            <template v-for="(h,hi) in module_headers" v-slot:[`header.${h.value}`]="{ header }">
              <v-tooltip top :key="hi" :class="header">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{h.text}}</span>
                </template>
                <span>{{h.description}}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.icon`]="{ item }">
              <v-icon
                :color="item.iconColor"
                :size="32"
              >
              {{item.icon}}
              </v-icon>
            </template>

            <template v-slot:[`item.dPrice`]="{ item }">
              <div>
                {{ item.dPrice}}
              </div>
            </template>

            <template v-slot:[`item.expiry`]="{ item, index }">
                <v-menu
                  v-model="menu[index]"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  color="info"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.expiry"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      color="info"
                      hide-details
                      
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.expiry"
                    locale="it"
                    dense
                    @input="save(item,'expiry');menu[index] = false" 
                  ></v-date-picker>
                </v-menu>               
            </template>

            <template v-slot:[`item.price`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step="1" 
                name="Price"
                hide-details
                @input.native="save(item,'price')" 
                v-model="item.price" 
                :value="(item.price/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.inboundPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="inboundPrice"
                hide-details
                @input.native="save(item,'inboundPrice')" 
                v-model="item.inboundPrice" 
                :value="(item.inboundPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.forwardPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="forwardPrice"
                hide-details
                @input.native="save(item,'forwardPrice')" 
                v-model="item.forwardPrice" 
                :value="(item.forwardPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.forwardMobilePrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="forwardMobilePrice"
                hide-details
                @input.native="save(item,'forwardMobilePrice')" 
                v-model="item.forwardMobilePrice" 
                :value="(item.forwardMobilePrice/1)">
              </v-text-field>
            </template>            

            <template v-slot:[`item.forwardAIPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="forwardAIPrice"
                hide-details
                @input.native="save(item,'forwardAIPrice')" 
                v-model="item.forwardAIPrice" 
                :value="(item.forwardAIPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.TTSPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="TTSPrice"
                hide-details
                @input.native="save(item,'TTSPrice')" 
                v-model="item.TTSPrice" 
                :value="(item.TTSPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.WAUtilityMessagePrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="WAUtilityMessagePrice"
                hide-details
                @input.native="save(item,'WAUtilityMessagePrice')" 
                v-model="item.WAUtilityMessagePrice" 
                :value="(item.WAUtilityMessagePrice/1)">
              </v-text-field>
            </template>  

            <template v-slot:[`item.WAMarketingMessagePrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="WAMarketingMessagePrice"
                hide-details
                @input.native="save(item,'WAMarketingMessagePrice')" 
                v-model="item.WAMarketingMessagePrice" 
                :value="(item.WAMarketingMessagePrice/1)">
              </v-text-field>
            </template>                        

          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_confirm"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Confermi Operazione?
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="save(selectedCustomer.accountId,'all','dueDate')">
                <v-icon color="info">mdi-check-bold</v-icon>
              </v-btn>
            </template>
            <span>Esegui</span>
          </v-tooltip> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_confirm=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>                     
        </v-card-title>
      </v-card>
    </v-dialog> 
    <v-dialog
      v-model="dialog_range"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Scegli Periodo
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_range=false;customers=[];getData()">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4">
          <v-date-picker
            v-model="dateRange"
            scrollable
            range
            color="info"
            show-adjacent-months
            full-width
            :first-day-of-week="1"
            locale="it"
            show-week
          >
          </v-date-picker>
        </v-card>
      </v-card>
    </v-dialog>          
    <v-snackbar v-model="snackbar" top right :width="120" :color="snackbar_color" style='z-index:20001;'>
      <span>{{snackbar_message}}</span>
    </v-snackbar>
  </div>
</template>
<style scoped>
.v-input__slot{
  min-height:30px!important;
  max-height:20px!important;
}
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import _ from 'lodash'

export default {
  components: { NoData, SkeletonRevenue, ExcelIcon },
  computed : {
    ...mapGetters(["settings"]),
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
    today:function()
    {
      var yourDate=new Date();
      const of = yourDate.getTimezoneOffset()
      yourDate = new Date(yourDate.getTime() - (of*60*1000))
      return yourDate.toISOString().split('T')[0]
    },
    totAmountWA:function()
    {
      var t1=this.selectedCustomer.amountWAMMarketing?this.selectedCustomer.amountWAMMarketing:0
      var t2=this.selectedCustomer.amountWAUtility?this.selectedCustomer.amountWAUtility:0
      var t3=(t1+t2).toFixed(3)
      console.log(688,t3)
      return t3
    },
    totCostWA:function()
    {
      var t1=this.selectedCustomer.waCostMarketing?this.selectedCustomer.waCostMarketing:0
      var t2=this.selectedCustomer.waCostUtility?this.selectedCustomer.waCostUtility:0
      var t3=(t1+t2).toFixed(3)
      console.log(695,t3)
      return t3
    },
    totCostPBX:function()
    {
      var t1=this.selectedCustomer.costForward?this.selectedCustomer.costForward:0
      var t2=this.selectedCustomer.costForwardMobile?this.selectedCustomer.costForwardMobile:0
      var t3=this.selectedCustomer.costTTS?this.selectedCustomer.costTTS:0
      var t4=this.selectedCustomer.costInbound?this.selectedCustomer.costInbound:0
      var t5=(t1+t2+t3+t4).toFixed(3)
      console.log(705,t5)
      return t5
    },
    totAmountPBX: function()
    {
      var t1=this.selectedCustomer.amountForward?this.selectedCustomer.amountForward:0
      var t2=this.selectedCustomer.amountForwardMobile?this.selectedCustomer.amountForwardMobile:0
      var t3=this.selectedCustomer.amountInbound?this.selectedCustomer.amountInbound:0
      var t4=(t1+t2+t3).toFixed(3)
      console.log(695,t4)
      return t4
    },
    totals() {
      const totals = this.customers.reduce((acc, d) => {
        acc.totCostPBX += d.totCostPBX||0
        acc.totCostWA += d.totCostWA||0
        acc.totAmountPBX += d.totAmountPBX||0
        acc.totAmountWA += d.totAmountWA||0
        acc.totAmountWAM += d.totAmountWAM||0
        return acc
      }, {
          totCostPBX: 0,
          totCostWA: 0,
          totAmountPBX: 0,
          totAmountWA: 0,
          totAmountWAM:0
        })
        console.log(890,totals)
      return totals
    }    
  },
  data() {
    return {
      namespace: "Reports",
      page: "BossUsers",
      UserID:null,
      username:'',
      formValid:true,
      pl_dialog:false,
      dialog_modules:false,
      dialog_invoicing:false,
      dialog_range:false,
      dialog_confirm:false,
      active_pricelist:null,
      custom_pricelist:[],
      menu:[],
      msg_modal:false,
      msg:{},
      htmlBody:'',
      wIH:window.innerHeight,
      loading: true,
      errorid: null,
      search: '',
      customers: [],
      info_dialog:false,
      snackbar:false,
      snackbar_message:'',
      snackbar_color:'',
      sendbutton_color:'info',
      sendbutton_text:'Send',
      sendingmail:false,
      //pickedDate:null,
      selectedCustomer:null,
      dateRange:[(new Date(new Date().getFullYear(),new Date().getMonth(), 2)).toISOString().substring(0, 10),(new Date(new Date().getFullYear(),new Date().getMonth()+1, 1)).toISOString().substring(0, 10)],
      rangeString:null,
      invoiceRemarks:'',
      invoiceRemarks2:'',
      forceExpiry:null,
      dateForAllModules:null,
      headers: [
        //{ text: 'Log', value: 'password' },

        { text: 'Attivo',     value: 'active',class:'text-button font-weight-bold' },
        //{ text: 'Scaduto',    value: 'expired',class:'text-button font-weight-bold' },
        { text: 'Ag',     value: 'agentId',align:'start',class:'text-button font-weight-bold' },
        { text: 'Start/Stop',value: 'createdDate', align: 'start',class:'text-button font-weight-bold'},
        //{ text: 'Scadenza',   value: 'expiryDate', align: 'start',class:'text-button font-weight-bold'},
        { text: 'GG',     value: 'duration', align: 'start',class:'text-button font-weight-bold'},
        //{ text: 'Group', value: 'group' },
        { text: 'Insegna',    value: 'brand',class:'text-button font-weight-bold' },
        { text: 'Città',      value: 'city', align: 'start',class:'text-button font-weight-bold' },
        //{ text: 'Telefono',   value: 'phone', align: 'center',class:'text-button font-weight-bold' },
        //{ text: 'Scadenza',   value: 'expiry', align: 'center',class:'text-button font-weight-bold' },        
        { text: 'PEC',        value: 'pec', align: 'center',class:'text-button font-weight-bold' },    

        { text: 'PBX',  value: 'totCostPBX',class:'text-button font-weight-bold error--text', description:'Costo Segreteria',align: 'end' },
        { text: 'PBX', value: 'totAmountPBX',class:'text-button font-weight-bold success--text', description:'Ricavo Segreteria',align: 'end' },
        //{ text: 'FWD',        value: 'FWD_Amount',class:'text-button font-weight-bold success--text', description:'Imp. Trasferimenti',align: 'end' },
        { text: 'WA',  value: 'totCostWA',class:'text-button font-weight-bold error--text', description:'Costi WhatsApp',align: 'end' },
        { text: 'WA',  value: 'totAmountWAM',class:'text-button font-weight-bold success--text', description:'Ricavo WhatsApp',align: 'end' },
        { text: 'Totali €',        value: 'totCosts',class:'text-button font-weight-bold info--text', description:'Totali Costi/Ricavi',align: 'end' },
        { text: 'Margine',        value: 'priceWAUtility',class:'text-button font-weight-bold', description:'Margine %',align: 'end' },
        
/*
        { text: 'FWD',        value: 'FWD_Amount',class:'text-button font-weight-bold success--text', description:'Imp. Trasferimenti',align: 'end' },
        //{ text: 'FWD M',      value: 'FWD_Mobile_Amount',class:'text-button font-weight-bold success--text', description:'Imp. Trasferimenti a Mobile',align: 'end' },
        //{ text: 'FWD AI',     value: 'FWD_AI_Amount',class:'text-button font-weight-bold success--text', description:'Imp. Trasferimenti ad AI',align: 'end' },
        { text: 'FWD',        value: 'FWD_Cost',class:'text-button font-weight-bold error--text', description:'Costo Trasferimenti',align: 'end' },
        //{ text: 'FWDM C',     value: 'FWD_Mobile_Cost',class:'text-button font-weight-bold error--text', description:'Costo Trasferimenti a Mobile',align: 'end' },
        { text: 'PBX',        value: 'Incoming_Cost',class:'text-button font-weight-bold error--text', description:'Costo Chiamate',align: 'end' },
        { text: 'TTS',        value: 'TTS_Cost',class:'text-button font-weight-bold error--text', description:'Costo TTS',align: 'end' },
        { text: 'WA U',       value: 'WA_Utility_Amount',class:'text-button font-weight-bold success--text', description:'Imp. WA Utility',align: 'end' },
        { text: 'WA M',       value: 'WA_Marketing_Amount',class:'text-button font-weight-bold success--text', description:'Imp. WA Marketing',align: 'end' },
        
        { text: 'WA C',       value: 'WA_Cost',class:'text-button font-weight-bold error--text', description:'Costo Messaggi WA',align: 'end' },

        { text: 'WA CONV',    value: 'WA_Conversations',class:'text-button font-weight-bold' , description:'Numero Conversazioni WA',align: 'end'},
        //{ text: 'VA U',       value: 'WA_Marketing',class:'text-button font-weight-bold', description:'Numero Conv. M' },
        { text: 'WA MSG',     value: 'WA_MSG_Count',class:'text-button font-weight-bold', description:'Numero Messaggi WA',align: 'end' },
        */
        { text: 'Dettagli',   value: 'cid', align: 'center' ,class:'text-button font-weight-bold', description:'Emetti Fattura',align: 'end'},
        { text: 'Moduli',     value: 'modules', align: 'center' ,class:'text-button font-weight-bold', description:'Prezzi Moduli',align: 'end'},
      ],
      module_headers:[
        { text: '', value: 'icon', align: 'center',class:'text-button font-weight-bold' },
        { text: 'Modulo', value: 'productName', align: 'start',class:'text-button font-weight-bold' },
        { text: 'Scadenza', value: 'expiry', align: 'center', width:"200",class:'text-button font-weight-bold' },
        { text: 'Listino', value: 'dPrice', align: 'end', width:"120",class:'text-button font-weight-bold' },
        { text: 'Prezzo', value: 'price', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Prezzo Modulo' },
        //{ text: 'TTS', value: 'TTSPrice', align: 'center',width: "120" },
        { text: 'INB', value: 'inboundPrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Chiamate in Entrata' },
        { text: 'FWD', value: 'forwardPrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Trasferimento chiamate i a Fisso' },
        { text: 'FWD M', value: 'forwardMobilePrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Trasferimento chiamate a Mobile' },
        { text: 'FWD AI', value: 'forwardAIPrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Trasferimenti ad AI' },
        { text: 'WA U', value: 'WAUtilityMessagePrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Prezzo Messaggio WA Utility' },
        { text: 'WA M', value: 'WAMarketingMessagePrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Prezzo Messaggio WA Marketing' },
      ],
      priceRules: [ 
            v => ( v >= 0 ) || this.$t(this.page+".Rate cannot be negative"),
            v => ( v <= 100 ) || this.$t(this.page+".To indicate ")+v+"% "+this.$t(this.page+'.enter')+' '+ v/100
        ],       
      rateRules: [ 
            v => ( v >= 0 ) || this.$t(this.page+".Rate cannot be negative"),
            v => ( v <= 100 ) || this.$t(this.page+".To indicate ")+v+"% "+this.$t(this.page+'.enter')+' '+ v/100
        ],              
    };
  },
  created(){
    this.$vuetify.theme.dark = true
    this.getData()
  },
  watch : {

  },
  methods:
  {
    copyToClipboard(txt)
    {
      navigator.clipboard.writeText(txt);
      this.snackbar_color="success"
      this.snackbar_message ='Copiato negli Appunti';
      this.snackbar = true;
    },    
    range_string()
    {
      console.log(260,this.dateRange)
      var date = new Date(this.dateRange[0]), y = date.getFullYear(), m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);
      this.monthName=firstDay.toLocaleString('it',{month:"long"})
      console.log(683,firstDay,lastDay,firstDay.toLocaleDateString('it', options) + ' - ' + lastDay.toLocaleDateString('it', options))
      const options={ year: 'numeric', month: '2-digit', day: '2-digit' };
      //return new Date(this.dateRange[0]).toLocaleDateString('it', options) + ' - ' + new Date(this.dateRange[1]).toLocaleDateString('it', options)
      var k=firstDay.toLocaleDateString('it', options) + ' - ' + lastDay.toLocaleDateString('it', options)
      this.rangeString=k;
      console.log(867,k,this.monthName)
      //return k
    },    
    save: _.debounce(function (item,field,type='') {
      let jwt=sessionStorage.getItem('jwt');
      console.log(372,item,field,type,this.selectedCustomer);
      let vl='';
      let payload='';
      switch (type)
      {
        case 'all'://dateForAll
          vl=this.dateForAllModules;
          payload={"jwt":jwt,"payload":{"action":"edit_user","table": "User_Products", "field": field, "value": vl, "accountId":this.selectedCustomer.accountId, "productId":'all'}};

        break;
        case 'dueDate': //set expired all Modules and also Accounts
          vl=item[field]==='0'||item[field]===''?null:item[field];
          payload={"jwt":jwt,"payload":{"action":"expire_products_and_account", "table": "Accounts","field": field, "value": vl,"accountId":item, "productId":'all'}};
        break;
        case 'account': //disable account (cannot login)
          vl=item[field]==='0'||item[field]===''?null:item[field];
          payload={"jwt":jwt,"payload":{"action":"edit_accounts", "table": "Accounts","field": field, "value": vl,"accountId":item}};
        break;
        default:
          vl=item[field]==='0'||item[field]===''?null:item[field];
          payload={"jwt":jwt,"payload":{"action":"edit_user","table": "User_Products", "field": field, "value": vl, "productId": item.productId , "accountId":this.selectedCustomer.accountId}};
      }
      /*
      let payload=type=='dueDate'?{"jwt":jwt,"payload":{"action":"edit_accounts", "table": "Accounts","field": field, "value": vl,"accountId":item}}
      :{"jwt":jwt,"payload":{"action":"edit_user","table": "User_Products", "field": field, "value": vl, "productId": item.productId , "accountId":this.selectedCustomer.accountId}};
      */
      console.log(374,vl,payload,this.formValid)
      if(this.formValid)
      {
        this.update_db(payload)
      }
      else
      {
        console.log(441,'invalid values in form')
        this.snackbar_color='error';
        this.snackbar_message=this.$t(this.page+'.Invalid value/s in a field: Change not saved');
        this.snackbar=true;
      }

    }, 1000),     
    async update_db(payload){
      
      try
      {
          const res = await this.$http.post('/boss/actions.php', payload);
          //const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,"payload":{"action":"pricelist","field":field,"userid":item.uuid,"value":value}});
          switch (res.data.errorid)
          {
            case '0':
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              console.log(257,res.data.message);
              this.snackbar=true;
               console.log(259,this.snackbar);
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
            default:
              this.snackbar_color='red darken-2';
              this.snackbar_message=res.data.message;
          }
      }
      catch(e)
      {
          console.log(264,e);
          this.snackbar_color='red darken-2';
          this.snackbar_message='Connection Error - Try Later';
      }
      console.log(276)
      this.snackbar=true;
    },
    /*  
    async toggle(item,field,type=''){
      let jwt=sessionStorage.getItem('jwt');
      try
      {
          //'{"table": "PriceLists", "field": "active", "value": 1, "key": "id", "keyValue": 6}'
          console.log(372,item,field,type);
          let vl=item[field]==='0'||item[field]===''?null:item[field];
          let payload=type=='cpl'?{"jwt":jwt,"payload":{"action":"edit_custom_pl", "field": field, "value": vl, "pricelistId": item.pricelistId,"uuid":item.uuid}}:{"jwt":jwt,"payload":{"action":"edit_user","table": "Users", "field": field, "value": vl, "key": "uuid", "keyValue": item.uuid}};
         
          console.log(374,vl,payload)
          const res = await this.$http.post('/boss/actions.php', payload);
          //const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,"payload":{"action":"pricelist","field":field,"userid":item.uuid,"value":value}});
          switch (res.data.errorid)
          {
            case '0':
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              console.log(257,res.data.message);
              this.snackbar=true;
               console.log(259,this.snackbar);
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
            default:
              this.snackbar_color='red darken-2';
              this.snackbar_message=res.data.message;
          }
      }
      catch(e)
      {
          console.log(264,e);
          this.snackbar_color='red darken-2';
          this.snackbar_message='Connection Error - Try Later';
      }
      console.log(276)
      this.snackbar=true;
    },
    */
    dialog_invoicing_open(item)
    {
      this.invoiceRemarks='Servizi iBookrestaurant relativi al mese di '+ this.monthName.toUpperCase() +':'
      this.invoiceRemarks+='<br>Conversazioni WhatsApp Utility Fatturate n. '+ item.countWAUtility +' (Messaggi WhatsApp Utility inviati '+ item.countWAMUtility+')';
      this.invoiceRemarks+='<br>Conversazioni WhatsApp Marketing Fatturate n. '+item.countWAMMarketing;//+' (Messaggi WhatsApp Marketing inviati '+item.countWAMMarketing+')';
      this.invoiceRemarks+='<br>Chiamate in Ingresso: '+item.minutesInbound+' minuti';
      this.invoiceRemarks+='<br>Deviazione Chiamate su Fisso: '+item.minutesForward+' minuti';
      this.invoiceRemarks+='<br>Deviazione Chiamate su Mobile: '+item.minutesForwardMobile+' minuti';
      const regex = /<br>/gm;
      const subst = `\n`;
      this.invoiceRemarks2=this.invoiceRemarks.replace(regex, subst)
      this.selectedCustomer=item;
      this.dialog_invoicing=true;
    },
    dialog_modules_open(item)
    {
      this.dialog_modules=true;
      this.selectedCustomer=item;
    },
    openModal(userid,username)
    {
      this.msg_modal=true;
      this.msg.userid=userid;
      this.username=username;
      this.sendbutton_color='info';
      this.sendbutton_text='Send';
    },
    async messageSend(){
      let jwt=sessionStorage.getItem('jwt');
      this.msg.action='message_send';
      if (this.sendbutton_text=='Send')
      {
        this.sendingmail=true;
        console.log({"jwt":jwt,'action':'messagesend','userid':JSON.stringify(this.msg)});
        try
        {
            const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,'payload':this.msg});
            switch (res.data.errorid)
            {
              case '0':
                this.snackbar_color='success';
                this.snackbar_message=res.data.message;
                console.log(298,res.data.message);
                this.snackbar=true;
                console.log(300,this.snackbar);
                this.sendbutton_color='primary';
                this.sendbutton_text='Sent';
              break;

              case '0006':
                this.$router.push('/auth/login').catch(() => {});
              break;
              default:
                this.snackbar_color='red darken-2';
                this.snackbar_message=res.data.message;
            }
        }
        catch(e)
        {
            console.log(e);
            this.snackbar_color='red darken-2';
            this.snackbar_message='Connection Error - Try Later';
        }
        this.sendingmail=false;
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message='Message already sent';
      }
        console.log(317)
        this.snackbar=true;
    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"jwt":jwt};
      window.location.href='/ajax/boss/customers_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async getData(){
      let jwt=sessionStorage.getItem('jwt');
      this.range_string();
      this.loading=true;
      try
      {
          const payload=JSON.stringify({"dateRange": this.dateRange,"date": this.date,"action":"getAccounts"});
          const res = await this.$http.post('/boss/users.php', payload );
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.customers=res.data.payloads.allAccounts;
              //console.log(this.customers);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
    async impersonate(e,p)
    {
      if(p)
      {
        this.loader=true;    
    	  //localStorage.clear();
	      localStorage.removeItem('user');
	      //sessionStorage.clear();
	      sessionStorage.removeItem('jwt');
        try
        {
          const res = await this.$http.post('/auth/login.php', {email: e, password: p, rememberme: true})
          this.errorid=res.data.errorid;
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            res.data.user.jwt=res.data.jwt;
            this.$store.dispatch("setUser", res.data.user); 
            this.$store.dispatch("setFixings", res.data.fixings);
            //this.$store.dispatch("setLocale", res.data.user.locale);
            //this.$store.dispatch("setCurrency", res.data.user.currency);
            //this.$store.dispatch("set_timeframe", res.data.user.timeframe); 
            
            if (res.data.ls_user)
            {
              localStorage.setItem('user', JSON.stringify(res.data.ls_user));
              //localStorage.setItem('user', res.data.user);
            }
            else
            {
              localStorage.removeItem('user');
            }
            this.$router.push('/'+res.data.user.landingpage).catch(() => {});
          }
          else
          {
            this.message=res.data.message;
            this.dialog=true;
          }
        }       
        catch(e)
        {
          this.$router.push('/auth/login').catch(() => {});
        }
        this.loader=false;
      }
      else
      {
        this.snackbar=true;
        this.snackbar_message='Missing PWD';
        this.snackbar_color='red';
      }
    },
  }
};
</script>
<style>
.v-data-table-header th {
  white-space: nowrap;
}
</style>